
import React from 'react';
import { Link } from 'react-router-dom';

const SuccessfulTransition: React.FC = () => {
  return (
    <>
      <h2 className="text-2xl font-bold mb-4 mt-8 text-itmgmt-dark-blue" id="successful-transition">Making a Successful Transition Between Models</h2>
      <p className="mb-4 text-gray-700 leading-relaxed">
        When you decide to change your IT support approach, consider these best practices for a smooth transition:
      </p>
      
      <ol className="list-decimal ml-6 mb-6 text-gray-700 leading-relaxed">
        <li className="mb-3">
          <strong>Start with assessment:</strong> Thoroughly document your current systems, credentials, and processes before any transition. Our <Link to="/book" className="text-itmgmt-medium-blue hover:text-itmgmt-bright-blue underline">IT assessment service</Link> can help establish your baseline.
        </li>
        <li className="mb-3">
          <strong>Phase the transition:</strong> Move services gradually rather than changing everything at once.
        </li>
        <li className="mb-3">
          <strong>Over-communicate:</strong> Keep everyone informed about changes, timelines, and expected impacts.
        </li>
        <li className="mb-3">
          <strong>Set clear expectations:</strong> Document service level agreements, response times, and responsibilities.
        </li>
        <li className="mb-3">
          <strong>Build relationships:</strong> Technology management is ultimately about people working together effectively.
        </li>
      </ol>
    </>
  );
};

export default SuccessfulTransition;
